import { Component, inject } from '@angular/core';
import { ToastService } from './toast.service';
import { NgbToast } from '@ng-bootstrap/ng-bootstrap';


@Component({
	selector: 'app-toast',
	imports: [NgbToast],
	template: `
		@for (toast of toastService.toasts; track toast) {
		  <ngb-toast
		    [class]="toast.classname"
		    [autohide]="true"
		    [delay]="toast.delay"
		    (hidden)="toastService.remove(toast)"
		    >
		    <div class="d-flex align-items-center">
		      <i class="bi {{toast.icon}}"></i>
		      <div>
		        @if (toast.title) {
		          <strong>{{toast.title}}<br></strong>
		        }
		        <span>{{toast.message}}</span>
		      </div>
		    </div>
		  </ngb-toast>
		}
		`,
	host: { class: 'toast-container position-fixed top-0 end-0 p-3', style: 'z-index: 1200' },
})
export class ToastComponent {
	toastService = inject(ToastService);

}
